import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { X, Search, ArrowUp, ArrowDown } from 'lucide-react';

interface ProductFiltersProps {
  statusFilter: string;
  searchQuery: string;
  categoryFilter: string;
  sortBy: string;
  sortOrder: 'asc' | 'desc';
  onStatusChange: (value: string) => void;
  onSearchChange: (value: string) => void;
  onCategoryChange: (value: string) => void;
  onSortByChange: (value: string) => void;
  onSortOrderToggle: () => void;
  onClearFilters: () => void;
}

export const ProductFilters = ({
  statusFilter,
  searchQuery,
  categoryFilter,
  sortBy,
  sortOrder,
  onStatusChange,
  onSearchChange,
  onCategoryChange,
  onSortByChange,
  onSortOrderToggle,
  onClearFilters
}: ProductFiltersProps) => {
  return (
    <div className="space-y-4 p-4 bg-muted/50 rounded-lg border mb-6">
      <div className="flex items-center justify-between">
        <h3 className="font-semibold flex items-center gap-2">
          <Search className="h-4 w-4" />
          Filtres et recherche
        </h3>
        <Button variant="ghost" size="sm" onClick={onClearFilters}>
          <X className="h-4 w-4 mr-2" />
          Réinitialiser
        </Button>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <div className="space-y-2">
          <Label>Statut</Label>
          <Select value={statusFilter} onValueChange={onStatusChange}>
            <SelectTrigger>
              <SelectValue placeholder="Tous" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Tous</SelectItem>
              <SelectItem value="active">Actif</SelectItem>
              <SelectItem value="inactive">Inactif</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <Label>Catégorie</Label>
          <Select value={categoryFilter} onValueChange={onCategoryChange}>
            <SelectTrigger>
              <SelectValue placeholder="Toutes" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Toutes</SelectItem>
              <SelectItem value="Électronique">Électronique</SelectItem>
              <SelectItem value="Vêtements">Vêtements</SelectItem>
              <SelectItem value="Alimentation">Alimentation</SelectItem>
              <SelectItem value="Maison">Maison</SelectItem>
              <SelectItem value="Sport">Sport</SelectItem>
              <SelectItem value="Beauté">Beauté</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <Label>Recherche</Label>
          <Input
            placeholder="Titre, marque..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
          />
        </div>

        <div className="space-y-2">
          <Label>Trier par</Label>
          <div className="flex gap-2">
            <Select value={sortBy} onValueChange={onSortByChange}>
              <SelectTrigger className="flex-1">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="created_at">Date création</SelectItem>
                <SelectItem value="title">Nom</SelectItem>
                <SelectItem value="price">Prix</SelectItem>
                <SelectItem value="stock">Stock</SelectItem>
              </SelectContent>
            </Select>
            <Button
              variant="outline"
              size="icon"
              onClick={onSortOrderToggle}
            >
              {sortOrder === 'asc' ? <ArrowUp className="h-4 w-4" /> : <ArrowDown className="h-4 w-4" />}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
